import { z } from "zod";

export const geofenceEventTypeSchema = z.enum([
  "CLOCK_IN",
  "CLOCK_OUT",
  "MANAGER_SUBMIT",
  "MANUAL_ENTRY",
]);

export const geofenceStatusSchema = z.enum([
  "VERIFIED_ON_SITE",
  "OUTSIDE_GEOFENCE",
  "GPS_UNAVAILABLE",
  "MANUAL_ENTRY",
  "MANAGER_OVERRIDE",
]);

export const geolocationInputSchema = z.object({
  latitude: z.number().min(-90).max(90),
  longitude: z.number().min(-180).max(180),
  accuracyMeters: z.number().min(0).optional().nullable(),
});

export const siteGeofenceConfigSchema = z.object({
  enabled: z.boolean(),
  strictMode: z.boolean(),
  latitude: z.number().nullable(),
  longitude: z.number().nullable(),
  radiusMeters: z.number().int().positive().nullable(),
});

export const geofenceEventSchema = z.object({
  id: z.string().uuid(),
  companyId: z.string().uuid(),
  siteId: z.string().uuid(),
  workerId: z.string().uuid().nullable(),
  timeEntryId: z.string().uuid().nullable(),
  actorUserId: z.string().uuid(),
  eventType: geofenceEventTypeSchema,
  latitude: z.number().nullable(),
  longitude: z.number().nullable(),
  accuracyMeters: z.number().nullable(),
  distanceFromSiteMeters: z.number().nullable(),
  status: geofenceStatusSchema,
  overrideReason: z.string().nullable(),
  deviceInfo: z.string().nullable(),
  createdAt: z.string(),
});

export const fieldClockInputSchema = z.object({
  siteId: z.string().uuid(),
  workerId: z.string().uuid(),
  action: z.enum(["CLOCK_IN", "CLOCK_OUT"]),
  geolocation: geolocationInputSchema.optional().nullable(),
  deviceInfo: z.string().trim().max(500).optional().nullable(),
  overrideReason: z.string().trim().max(500).optional().nullable(),
});

export const fieldClockResponseSchema = z.object({
  accepted: z.boolean(),
  message: z.string(),
  geofenceStatus: geofenceStatusSchema.nullable(),
  distanceFromSiteMeters: z.number().nullable(),
});

export type GeofenceEventType = z.infer<typeof geofenceEventTypeSchema>;
export type GeofenceStatus = z.infer<typeof geofenceStatusSchema>;
export type GeolocationInput = z.infer<typeof geolocationInputSchema>;
export type SiteGeofenceConfig = z.infer<typeof siteGeofenceConfigSchema>;
export type GeofenceEvent = z.infer<typeof geofenceEventSchema>;
export type FieldClockInput = z.infer<typeof fieldClockInputSchema>;
export type FieldClockResponse = z.infer<typeof fieldClockResponseSchema>;
